export default "/react/modal-realty-b34cfdde.png";